export default __webpack_public_path__ + "static/media/16.64747235.jpg";